module.exports = __webpack_public_path__ + "static/media/it.605295f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/it.svg
// module id = 1453
// module chunks = 0